import React, { useState } from "react";
import tierIcon from '../../../assets/partnership/tier.svg';
import compensationIcon from '../../../assets/partnership/compensation.svg';
import differentiationIcon from '../../../assets/partnership/differentiation.svg';
import promotionIcon from '../../../assets/partnership/promotion.svg';
import integrationIcon from '../../../assets/partnership/integration.svg';

import './PartnershipCategoryValue.scss';
import ProgramCategoryBox from "../Widgets/ProgramCategoryBox";

const PartnershipCategoryValue = props => {
	const {showFloater, programs, item} = props;
	const [showPartnershipBox, setShowPartnershipBox] = useState(null);
	const value = programs.length;
	let icon;

	switch (item) {
		case 'Tier':
			icon = tierIcon;
			break;
		case 'Compensation':
			icon = compensationIcon;
			break;
		case 'Differentiation':
			icon = differentiationIcon;
			break;
		case 'Promotion':
			icon = promotionIcon;
			break;
		case 'Integration':
			icon = integrationIcon;
			break;
	}

	const foreColor = value === 0 ? '#88ABB4' : '#FFFFFF';
	const backColor = value === 0 ? '#D3E1ED' : '#40a0c1';

	return (
		<div className="partnership-circle-value-container" onMouseOver={() => showFloater && setShowPartnershipBox(item)}>
			<img src={icon} alt="" style={{width: '15px', paddingRight: '5px'}} />
			<div style={{color: '#062229'}}>{item}</div>
			<div className="partnership-circle-value" style={{backgroundColor: backColor, color: foreColor}}>{value}</div>

			{
				showPartnershipBox && programs.length > 0 &&
				<div className="partnership-circle-value-data-box-floater" onMouseLeave={() => showFloater && setShowPartnershipBox(null)}>
					<div className="partnership-circle-value-data-box">
						<ProgramCategoryBox programs={programs}>{item}</ProgramCategoryBox>
					</div>
				</div>
			}
		</div>
	)
};

export default PartnershipCategoryValue;